/**
 * Copyright (C) 2013-2018 MNEMOTIX <http://www.mnemotix.com/> and/or its affiliates
 * and other contributors as indicated by the @author tags.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
import {MixedLinkInputDefinition} from "../../../form";

/**
 * @param {LinkInputDefinition} linkInputDefinition
 * @param {object} targetObject
 */
export function getLinkInputDefinitionForTargetObject({
  linkInputDefinition,
  targetObject
}) {
  if (linkInputDefinition instanceof MixedLinkInputDefinition) {
    if (!targetObject.__typename) {
      throw new Error(`LinkInputDefinition with name "${linkInputDefinition.name}" is typed as MixedLinkInputDefinition. 
To determine the right LinkInputDefinition, please ensure that submitted targetObject (${targetObject}) gets a "__typename" property.`);
    }

    linkInputDefinition = linkInputDefinition.getLinkDefinitionForTypename(targetObject.__typename);

    if (!linkInputDefinition) {
      throw new Error(`None of MixedLinkInputDefinition[name="${linkInputDefinition.name}"].mixedLinks define a "inputInheritedTypename" property matching target object "${targetObject.__typename}" typename. Found [${linkInputDefinition.mixedLinks.map(linkInputDefinition => linkInputDefinition.inputInheritedTypename).join(", ")}]`);
    }
  }

  return linkInputDefinition;
}